<div class="content_wrap">
  <div class="container-fluid">
    <div class="editor-main">
      <div class="scrollable_area">
        <div class="editor-data" [innerHTML]="htmlContent"></div>
      </div>
    </div>
  </div>
</div>
